import { Link } from 'react-router-dom'
import { Anchor } from '@mantine/core'
import SKU from '../../ui/SKU'
import QuantityDisplay from '@/components/ui/QuantityDisplay'
import ShopifyVariantBundleEdit from './ShopifyVariantBundleEdit'
import dayjs from 'dayjs'

export default function ShopifyVariantBundleView({
    variant,
    product,
    fetchProduct,
    sortedComponents,
    physicalAtLocation,
    availableAtLocationB2C,
    availableAtLocationB2B,
}) {
    const v = variant

    return (
        <>
            <pre className="hidden">{JSON.stringify(v, null, 2)}</pre>
            <div className="flex flex-col justify-center w-full border rounded-xl overflow-hidden">
                <div className="text-sm mt-1 divide-y">
                    <div className="grid grid-cols-[1fr_120px_120px_120px_120px_140px] justify-start font-medium text-sm">
                        <div className="p-2">Composant</div>
                        <div className="p-2 text-right">Physique</div>

                        <div className="p-2 text-right">Réservé</div>

                        <div className="p-2 text-right">B2C</div>

                        <div className="p-2 text-right">B2B</div>

                        <div className="p-2 text-right">Préparation</div>
                    </div>

                    {v.components.map((component) => {
                        return (
                            <div
                                key={component.id}
                                className="grid grid-cols-[1fr_120px_120px_120px_120px_140px] justify-start py-1"
                            >
                                <div className="flex gap-2 items-center truncate px-3">
                                    <span className="text-gray-700">
                                        ×{component.pivot.quantity}
                                    </span>

                                    <SKU size="sm" component={component} />

                                    <Link
                                        to={'/components/' + component.id}
                                        className="flex mr-auto p-1"
                                    >
                                        <Anchor component="span" size="sm">
                                            {component.full_name_fr}
                                        </Anchor>

                                        <div></div>
                                    </Link>
                                </div>

                                <div className="h-full flex items-center p-2 justify-end text-gray-400">
                                    <QuantityDisplay
                                        quantity={component.physicalAtLocation}
                                    />
                                </div>

                                <div className="h-full flex items-center p-2 justify-end text-gray-400">
                                    <QuantityDisplay
                                        quantity={component.holdAtLocation}
                                    />
                                </div>

                                <div className="h-full flex items-center p-2 justify-end text-gray-400">
                                    <QuantityDisplay
                                        quantity={component.availableAtLocation}
                                        disabledLabel={
                                            component.availability_b2c ===
                                            'force_disabled'
                                                ? 'Refusé'
                                                : null
                                        }
                                        unlimitedLabel={
                                            component.availability_b2c ===
                                            'force_available'
                                                ? 'Illimité'
                                                : null
                                        }
                                    />
                                </div>

                                <div className="h-full flex items-center p-2 justify-end text-gray-400">
                                    <QuantityDisplay
                                        quantity={component.availableAtLocation}
                                        disabledLabel={
                                            component.availability_b2b ===
                                            'force_disabled'
                                                ? 'Refusé'
                                                : null
                                        }
                                        unlimitedLabel={
                                            component.availability_b2b ===
                                            'force_available'
                                                ? 'Illimité'
                                                : null
                                        }
                                    />
                                </div>

                                <div className="h-full flex items-center p-2 justify-end text-gray-400">
                                    {component.dispatch_date ? (
                                        (() => {
                                            const date = dayjs(
                                                component.dispatch_date
                                            )
                                            return (
                                                <span className="text-orange-500">
                                                    {date.format('ll')}
                                                </span>
                                            )
                                        })()
                                    ) : (
                                        <span className="text-green-500">
                                            3 à 5 jours
                                        </span>
                                    )}
                                </div>
                            </div>
                        )
                    })}

                    <div className="grid grid-cols-[1fr_120px_120px_120px_120px_140px] justify-start text-sm font-medium bg-gray-50 border-t shadow-xs rounded-b-md">
                        <div className="p-3 flex items-center"></div>

                        <div className="p-3 text-right">
                            <div className="text-xs text-gray-400">
                                Physique
                            </div>
                            <div className="mt-1 text-base">
                                <QuantityDisplay
                                    quantity={physicalAtLocation}
                                />
                            </div>
                        </div>

                        <div className="p-3 text-right">
                            <div className="text-xs text-gray-400">Réservé</div>
                            <div className="mt-1 text-base">-</div>
                        </div>

                        <div className="p-3 text-right">
                            <div className="text-xs text-gray-400">B2C</div>
                            <div className="mt-1 text-base">
                                <QuantityDisplay
                                    quantity={availableAtLocationB2C}
                                    unlimitedLabel={
                                        v.components.every(
                                            (c) =>
                                                c.availability_b2c ===
                                                'force_available'
                                        )
                                            ? 'Illimité'
                                            : null
                                    }
                                    disabledLabel={
                                        v.components.some(
                                            (c) =>
                                                c.availability_b2c ===
                                                'force_disabled'
                                        )
                                            ? '-999'
                                            : null
                                    }
                                />
                            </div>
                        </div>

                        <div className="p-3 text-right">
                            <div className="text-xs text-gray-400">B2B</div>
                            <div className="mt-1 text-base">
                                <QuantityDisplay
                                    quantity={availableAtLocationB2C}
                                    unlimitedLabel={
                                        v.components.every(
                                            (c) =>
                                                c.availability_b2b ===
                                                'force_available'
                                        )
                                            ? 'Illimité'
                                            : null
                                    }
                                    disabledLabel={
                                        v.components.some(
                                            (c) =>
                                                c.availability_b2b ===
                                                'force_disabled'
                                        )
                                            ? 'Refusé'
                                            : null
                                    }
                                />
                            </div>
                        </div>

                        <div className="p-3 text-right">
                            <div className="text-xs text-gray-400">
                                Préparation
                            </div>

                            <div className="mt-1 text-base">
                                {v.components.some(
                                    (c) => c.dispatch_date
                                ) ? (
                                    (() => {
                                        const maxTimestamp = Math.max(
                                            ...v.components
                                                .filter((c) => c.dispatch_date)
                                                .map((c) =>
                                                    new Date(
                                                        c.dispatch_date
                                                    ).getTime()
                                                )
                                        )
                                        const maxDate = dayjs(maxTimestamp)

                                        return (
                                            <span className="text-orange-500 font-bold">
                                                {maxDate.format('ll')}
                                            </span>
                                        )
                                    })()
                                ) : (
                                    <span className="text-green-500 font-bold">
                                        3 à 5 jours
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ShopifyVariantBundleEdit
                fetchProduct={fetchProduct}
                product={product}
                variant={variant}
                sortedComponents={sortedComponents}
            />

            <div className="border rounded-xl p-5 hidden">
                <pre>{JSON.stringify(v, null, 2)}</pre>
            </div>
        </>
    )
}
